<template>
  <div class="products-filter-bar">
    <div class="products-filter-row">
      <search @updateFilter="setRouterQuery"/>
      <product-type @updateFilter="setRouterQuery"/>
      <variation @updateFilter="setRouterQuery"/>
      <quantity @updateFilter="setRouterQuery"/>
      <per-page @updateFilter="setRouterQuery"/>
      <multiple-store v-if="isAdmin" @updateFilter="setRouterQuery"/>
    </div>

    <button type="button" class="products-more-btn" @click="moreOpen = !moreOpen">
      <b-icon icon="funnel"></b-icon>
      <span>برند و دسته‌بندی</span>
      <b-icon :icon="moreOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
    </button>

    <div v-show="moreOpen" class="products-filter-more">
      <brand @updateFilter="setRouterQuery"/>
      <category @updateFilter="setRouterQuery"/>
    </div>
  </div>
</template>

<script>
import Search from "./Filters/Search";
import ProductType from "./Filters/ProductType";
import Variation from "./Filters/Variation";
import Quantity from "./Filters/Quantity";
import PerPage from "./Filters/PerPage";
import Brand from "./Filters/Brand";
import Category from "./Filters/Category/Category";
import MultipleStore from "./Filters/MultipleStore";
import {mapGetters} from "vuex";

export default {
  name: "Filters",
  components: {Search, ProductType, Variation, Quantity, PerPage, Brand, Category, MultipleStore},
  data() {
    return {
      moreOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin"
    })
  },
  methods: {
    setRouterQuery(value) {
      const valueKey = Object.keys(value)[0]
      if (['brand', 'category'].indexOf(valueKey) > -1 && Array.isArray(value[valueKey])) {
        value[valueKey] = value[valueKey]
          .map(item => (item && item.id != null) ? item.id : item)
          .join(',')
      }
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...value}})
    }
  }
}
</script>
